// extracted by mini-css-extract-plugin
module.exports = {"documentationWrapper":"Documentation_documentationWrapper__uxuju","document":"Documentation_document__EKj2m"};